import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLogStateMachine } from '@/idv/hooks';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import { useNonIdDocMachine } from '../../components/machine-provider';
import DesktopProcessing from '../desktop-processing';
import DesktopRetry from '../desktop-retry';
import DocumentPrompt from '../document-prompt';
import Init from '../init';
import MobileImageCapture from '../mobile-image-capture';
import MobileProcessing from '../mobile-processing';
import MobileRetry from '../mobile-retry';
type RouterProps = {
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(27);
  const {
    onDone
  } = t0;
  const [state, send] = useNonIdDocMachine();
  let t1;
  if ($[0] !== state) {
    t1 = state.matches("complete") || state.matches("failure");
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDone = t1;
  useLogStateMachine("non-id-doc", state);
  let t2;
  let t3;
  if ($[2] !== isDone || $[3] !== onDone) {
    t2 = () => {
      if (isDone) {
        onDone();
      }
    };
    t3 = [isDone, onDone];
    $[2] = isDone;
    $[3] = onDone;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (state.matches("init")) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Init />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (state.matches("documentPrompt")) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DocumentPrompt />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (state.matches("mobileRequestCameraAccess")) {
    let t4;
    if ($[8] !== send) {
      t4 = <CameraAccessRequest onClose={() => send({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => send({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => send({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => send({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[8] = send;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (state.matches("mobileCameraAccessDenied")) {
    let t4;
    if ($[10] !== send) {
      t4 = () => send({
        type: "navigatedToPrev"
      });
      $[10] = send;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== state.context.device || $[13] !== t4) {
      t5 = <CameraAccessDenied device={state.context.device} onClose={t4} />;
      $[12] = state.context.device;
      $[13] = t4;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  if (state.matches("mobileCameraErrored")) {
    let t4;
    if ($[15] !== send) {
      t4 = () => send({
        type: "navigatedToPrev"
      });
      $[15] = send;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    const t5 = state.context.cameraErrorCause ?? "other-error";
    let t6;
    if ($[17] !== t4 || $[18] !== t5) {
      t6 = <CameraError onBack={t4} cause={t5} />;
      $[17] = t4;
      $[18] = t5;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    return t6;
  }
  if (state.matches("mobileImageCapture")) {
    let t4;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileImageCapture />;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    return t4;
  }
  if (state.matches("mobileRetry")) {
    let t4;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileRetry />;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    return t4;
  }
  if (state.matches("desktopRetry")) {
    let t4;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DesktopRetry />;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    return t4;
  }
  if (state.matches("mobileProcessing")) {
    let t4;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileProcessing />;
      $[23] = t4;
    } else {
      t4 = $[23];
    }
    return t4;
  }
  if (state.matches("desktopProcessing")) {
    let t4;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DesktopProcessing />;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    return t4;
  }
  const t4 = `Router Non id doc flow. State name: ${state.value}`;
  let t5;
  if ($[25] !== t4) {
    t5 = <div>{t4}</div>;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};
export default Router;